import React, { useContext, useState, useCallback} from 'react';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { FirebaseContext } from '../../context/FirebaseContext';
// import SubjectDetails from './SubjectDetails/SubjectDetails';
// import AddSubject from './components/AddSubject';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { useQuery } from 'react-query';
import Input from '../../NecttosComp/Input/Input';
import Instruction from '../../Documentation/Instruction';

const categoryStyles = {
	taxonomy: {
		Creating: 'bg-purple-600',
		Evaluating: 'bg-indigo-600',
		Analysing: 'bg-blue-600',
		Applying: 'bg-green-600',
		Understanding: 'bg-yellow-600',
		Remembering: 'bg-red-600',
	},
	importance: {
		'Very Important': 'bg-red-500',
		Important: 'bg-yellow-500',
		Normal: 'bg-green-500',
	},
	difficulty: {
		Challenging: 'bg-red-600',
		Medium: 'bg-yellow-600',
		Easy: 'bg-green-600',
	},
	type: {
		Theory: 'bg-blue-500',
		Application: 'bg-green-500',
	},
};

function getColorForCategory(category, value) {
	return categoryStyles[category]?.[value] || 'bg-gray-400';
}

export const getSubjects = (id) => async () => {
	const instance = await getAxiosTokenInstance();
	const url = `/college/subject/getSubjectsWithId?id=${encodeURIComponent(id)}`;
	try {
		const resp = await instance.get(url);
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data?.subjectObject;
		}
	} catch (error) {
		throw new Error('API Error');
	}
};

function convertToList(text) {
	return text
		?.split(';')
		.map((item) => item.trim())
		.filter((item) => item)
		.map((item) => {
			const match = item.match(/^\d+\.\s*(.*)$/);
			return match ? match[1] : item;
		});
}

function MultiSelectDropdown({ fieldName, returnKey, state, setState, options }) {
	const handleSelectChange = (event) => {
		const value = Array.from(event.target.selectedOptions, (option) => option.value);
		setState({ ...state, [returnKey]: value });
	};

	return (
		<div className='w-full mb-4'>
			<label className='block text-sm font-medium text-gray-700'>{fieldName}</label>
			<select multiple={true} value={state[returnKey]} onChange={handleSelectChange} className='mt-1 block w-full p-2.5 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500'>
				{options.map((option, index) => (
					<option key={index} value={option}>
						{option}
					</option>
				))}
			</select>
		</div>
	);
}

function AddModule({ onClose, values }) {
	const [val, setVal] = useState(values || {});
	const [topicContent, setTopicContent] = useState('');
	const [modules, setModules] = useState(values?.points || []);

	const extractTopics = () => {
		const topics = topicContent
			.split(/;|\./)
			.map((topic) => topic.trim())
			.filter((topic) => topic.length > 0);
		setModules(topics);
		setTopicContent('');
	};

	const handleTopicChange = (index, value) => {
		const updatedModules = [...modules];
		updatedModules[index] = value;
		setModules(updatedModules);
	};

	const addTopic = () => {
		setModules([...modules, '']);
	};

	const removeTopic = (index) => {
		const updatedModules = [...modules];
		updatedModules.splice(index, 1);
		setModules(updatedModules);
	};

	const onSubmit = async () => {
		const instance = await getAxiosTokenInstance();
		instance
			.post(
				'/college/subject/updateSubjectModule',
				{
					name: val.name,
					hours: val.hours,
					marks: val.marks,
					partB: val.partB,
					partA: val.partA,
					partC: val.partC,
					taxonomy: val.taxonomy,
					difficulty: val.difficulty,
					important: val.important,
					type: val.type,
					points: modules,
				},
				{
					params: {
						subjectId: values.subjectId,
						moduleId: values?.moduleId,
					},
				},
			)
			.then(() => {
				onClose();
			})
			.catch((err) => {
				console.error(err);
			});
	};

	console.log({ val });
	return (
		<Main width='auto' height='auto' title='Module Management'>
			<div className='self-end'>
				<Button type='close' onClick={onClose}>
					Close
				</Button>
			</div>
			<Body>
				<div className='w-full max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-lg overflow-hidden'>
					<div className='w-full items-end'>
						<div className='self-end'></div>
					</div>
					<div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4'>
						<Input width='100%' fieldName='Module Name' returnKey='name' state={val} setState={setVal} type='text' />
						<Input width='100%' fieldName='Teaching Hours for this module' returnKey='hours' state={val} setState={setVal} type='number' />
						<Input width='100%' fieldName='Marks expected from this module' returnKey='marks' state={val} setState={setVal} type='number' />

						<Input width='100%' fieldName='Blueprint Part A Questions' returnKey='partA' state={val} setState={setVal} type='number' />
						<Input width='100%' fieldName='Blueprint Part B Questions' returnKey='partB' state={val} setState={setVal} type='number' />
						<Input width='100%' fieldName='Blueprint Part C Questions' returnKey='partC' state={val} setState={setVal} type='number' />

						<MultiSelectDropdown fieldName='Taxonomy' returnKey='taxonomy' state={val} setState={setVal} options={['Creating', 'Evaluating', 'Analysing', 'Applying', 'Understanding', 'Remembering']} />

						<MultiSelectDropdown fieldName='Difficulty' returnKey='difficulty' state={val} setState={setVal} options={['Challenging', 'Medium', 'Easy']} />

						<MultiSelectDropdown fieldName='Important' returnKey='important' state={val} setState={setVal} options={['Very Important', 'Important', 'Normal']} />

						<MultiSelectDropdown fieldName='Type' returnKey='type' state={val} setState={setVal} options={['Theory', 'Application']} />
					</div>

					<div className='my-4'>
						<label className='block text-sm font-medium text-gray-700'>Please paste the entire module content here, ensuring each topic is separated by a semicolon (;). Additionally, I'd like to include the functionality to copy and paste text within a text area. This method simplifies the process of splitting content.</label>
						<textarea className='mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500' rows='5' placeholder='Paste the entire topic content here' value={topicContent} onChange={(e) => setTopicContent(e.target.value)}></textarea>
						<button onClick={extractTopics} className='mt-2 bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'>
							Extract
						</button>
					</div>

					<div className='mb-4'>
						<label className='block text-sm font-medium text-gray-700'>Topics</label>
						{modules.map((topic, index) => (
							<div key={index} className='flex items-center gap-2 mb-2'>
								<input type='text' className='border border-gray-300 rounded-md shadow-sm py-2 px-3 leading-tight focus:outline-none focus:ring-blue-500 focus:border-blue-500 flex-grow' value={topic} onChange={(e) => handleTopicChange(index, e.target.value)} />
								<button onClick={() => removeTopic(index)} className='bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'>
									Delete
								</button>
							</div>
						))}
						<button onClick={addTopic} className='bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'>
							Add Topic
						</button>
					</div>
				</div>
			</Body>
			<Button
				type='save'
				onClick={() => {
					onSubmit();
				}}>
				Submit
			</Button>
		</Main>
	);
}

function AddSubject({ onClose, data }) {
	const [val, setVal] = useState({
		name: data?.name || '',
		shortName: data?.shortName || '',
		subjectCode: data?.subjectCode || '',
		lectureHour: data?.lectureHour || '',
		credit: data?.credit || '',
		internalMark: data?.internalMark || '',
		externalMark: data?.externalMark || '',
		examHour: data?.examHour || '',
		year: data?.year || '',
		partA: data?.partA || { questions: '', skip: '', mark: '' },
		partB: data?.partB || { questions: '', skip: '', mark: '' },
		partC: data?.partC || { questions: '', skip: '', mark: '' },
	});

	const { collegeId } = useContext(FirebaseContext);

	const addNewForm = async () => {
		try {
			const instance = await getAxiosTokenInstance();
			instance
				.post('/college/subject/addSubjects', {
					syllabus: {
						internalMark: val.internalMark,
						externalMark: val.externalMark,
						examHour: val.examHour,
						lectureHour: val.lectureHour,
						credit: val.credit,
					},
					partA: val.partA,
					partB: val.partB,
					partC: val.partC,
					shortName: val.shortName,
					name: val.name,
					year: val.year,
					subjectCode: val.subjectCode,
					collegeId,
					id: data?._id,
				})
				.then(() => {
					onClose();
				})
				.catch((err) => {
					console.error(err);
				});
		} catch (err) {
			throw new Error('API Error');
		}
	};
	const handleNestedChange = (part, key, valueObj) => {
		const value = valueObj.value;
		setVal((currentVal) => ({
			...currentVal,
			[part]: {
				...currentVal[part],
				[key]: value,
			},
		}));
	};

	return (
		<Main width='auto' height='auto' title='Add Subject'>
			<div className='flex justify-end p-4'>
				<Button type='close' onClick={onClose}>
					Close
				</Button>
			</div>
			<Body>
				<div className='w-[100vw] lg:w-[60vw]   md:w-[80vw]  max-w-4xl mx-auto bg-white p-8 rounded-lg shadow overflow-hidden'>
					<Input width='100%' fieldName='Subject Name' returnKey='name' state={val} setState={setVal} type='text' placeholder='Enter Subject Name' className='w-full' />
					<form className='grid grid-cols-1  sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6'>
						<Input width='100%' fieldName='Subject Short Name' returnKey='shortName' state={val} setState={setVal} type='text' placeholder='Enter Short Name' />
						<Input width='100%' fieldName='Subject Code' returnKey='subjectCode' state={val} setState={setVal} type='text' placeholder='Enter Subject Code' />
						<Input width='100%' fieldName='Lecture Hours per week' returnKey='lectureHour' state={val} setState={setVal} type='number' placeholder='Enter Lecture Hours' />
						<Input width='100%' fieldName='Credits' returnKey='credit' state={val} setState={setVal} type='number' placeholder='Enter Credits' />
						<Input width='100%' fieldName='Internal Mark out of' returnKey='internalMark' state={val} setState={setVal} type='number' placeholder='Enter Internal Marks' />
						<Input width='100%' fieldName='External Mark out of' returnKey='externalMark' state={val} setState={setVal} type='number' placeholder='Enter External Marks' />
						<Input width='100%' fieldName='Examination Hour' returnKey='examHour' state={val} setState={setVal} type='number' placeholder='Enter Exam Duration' />
						<Input width='100%' fieldName='Syllabus Year' returnKey='year' state={val} setState={setVal} type='number' placeholder='Enter Syllabus Year' />
					</form>

					<div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'>
						{['A', 'B', 'C'].map((part) => (
							<div key={part} className='space-y-4'>
								<Input width='100%' fieldName={`Part ${part} Total Questions`} state={val[`part${part}`].questions} onChange={(value) => handleNestedChange(`part${part}`, 'questions', value)} type='number' />
								<Input width='100%' fieldName={`Part ${part} Each Q Mark`} state={val[`part${part}`].mark} onChange={(value) => handleNestedChange(`part${part}`, 'mark', value)} type='number' />
								<Input width='100%' fieldName={`Part ${part} Skip`} state={val[`part${part}`].skip} onChange={(value) => handleNestedChange(`part${part}`, 'skip', value)} type='number' />
							</div>
						))}
					</div>
				</div>
			</Body>
			<div className='flex justify-center mt-8'>
				<Button type='save' onClick={addNewForm}>
					Submit
				</Button>
			</div>
		</Main>
	);
}

function ObjectiveEdit({ data, onClose }) {
	const [val, setVal] = useState(data);
	const { collegeId } = useContext(FirebaseContext);

	const addNewForm = async () => {
		try {
			const instance = await getAxiosTokenInstance();
			instance
				.post('/college/subject/addSubjects', {
					syllabus: {
						internalMark: val.internalMark,
						externalMark: val.externalMark,
						examHour: val.examHour,
						lectureHour: val.lectureHour,
						credit: val.credit,
						objectives: val.objectives,
						references: val.references,
					},
					partA: val.partA,
					partB: val.partB,
					partC: val.partC,
					shortName: val.shortName,
					name: val.name,
					year: val.year,
					subjectCode: val.subjectCode,
					collegeId,
					id: data?._id,
				})
				.then(() => {
					onClose();
				})
				.catch((err) => {
					console.error(err);
				});
		} catch (err) {
			throw new Error('API Error');
		}
	};

	return (
		<Main width='auto' height='auto'>
			<div className='bg-gray-100 p-4 sm:p-6 md:max-w-4xl lg:max-w-5xl xl:max-w-6xl mx-auto rounded-lg shadow-lg'>
				<div className='flex justify-end mb-4'>
					<Button type='close' onClick={onClose} className='text-white bg-red-500 hover:bg-red-600 font-medium py-2 px-4 rounded'>
						Close
					</Button>
				</div>

				<div className='space-y-6'>
					<h1 className='text-2xl font-bold text-center text-gray-800'>Edit Subject</h1>
					<div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
						<div>
							<label htmlFor='objective' className='block text-sm font-medium text-gray-700'>
								Objective
							</label>
							<textarea value={val?.objectives} id='objective' rows='10' className='mt-1 block w-full p-2.5 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500' onChange={(e) => setVal({ ...val, objectives: e.target.value })} placeholder='Enter objective details'></textarea>
						</div>
						<div>
							<label htmlFor='references' className='block text-sm font-medium text-gray-700'>
								References
							</label>
							<textarea value={val?.references} id='references' rows='10' className='mt-1 block w-full p-2.5 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500' placeholder='Enter references details' onChange={(e) => setVal({ ...val, references: e.target.value })}></textarea>
						</div>
					</div>
					<div className='flex justify-center mt-6'>
						<Button
							type='save'
							onClick={() => {
								addNewForm();
							}}
							className='text-white bg-blue-500 hover:bg-blue-600 font-medium py-2 px-4 rounded'>
							Submit
						</Button>
					</div>
				</div>
			</div>
		</Main>
	);
}

function SubjectDetails({ data: ids, onClose }) {
	const [edit, setEdit] = useState();
	const { data = {}, refetch } = useQuery(['getSubdddjects', ids?._id, edit], getSubjects(ids?._id));
	const { collegeId, user } = useContext(FirebaseContext);
	const [moduleData, setModuleData] = useState({});
	const getColorForCategoryMemo = useCallback(getColorForCategory, []);
	const convertToListMemo = useCallback(convertToList, []);

	return (
		<>
			<Main title={data?.name || 'Selected Subject'} height='auto' width='auto'>
				<Header>
					<Button type='close' onClick={onClose}>
						Close
					</Button>
				</Header>
				<Body>
					<div className='bg-white p-5 rounded-lg shadow-lg my-2'>
						<div className='flex justify-end mb-4'>
							<button
								className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded'
								onClick={() => {
									refetch();
									setEdit('main');
								}}>
								Edit
							</button>
						</div>

						<div className='space-y-6'>
							<h2 className='text-3xl font-bold text-gray-800 mb-6'>Subject Details</h2>
							<div className='grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-4'>
								<div className='bg-white p-6 rounded-lg shadow space-y-4'>
									<h3 className='text-xl font-semibold text-gray-700'>General Information</h3>
									<p className='text-gray-600'>
										<strong>Subject Name:</strong> {data?.name}
									</p>
									<p className='text-gray-600'>
										<strong>Short Name:</strong> {data?.shortName}
									</p>
									<p className='text-gray-600'>
										<strong>Subject Code:</strong> {data?.subjectCode}
									</p>
									<p className='text-gray-600'>
										<strong>Lecture Hours/Week:</strong> {data?.lectureHour}
									</p>
									<p className='text-gray-600'>
										<strong>Credits:</strong> {data?.credit}
									</p>
									<p className='text-gray-600'>
										<strong>Internal Mark:</strong> {data?.internalMark}
									</p>
									<p className='text-gray-600'>
										<strong>External Mark:</strong> {data?.externalMark}
									</p>
									<p className='text-gray-600'>
										<strong>Exam Hour:</strong> {data?.examHour}
									</p>
									<p className='text-gray-600'>
										<strong>Syllabus Year:</strong> {data?.year}
									</p>
								</div>
								<div className='grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-4'>
									{['A', 'B', 'C'].map((part) => (
										<div key={part} className='bg-white p-6 rounded-lg shadow space-y-4'>
											<h3 className='text-xl font-semibold text-gray-700'>Part {part}</h3>
											<p className='text-gray-600'>
												<strong>Total Questions:</strong> {data[`part${part}`]?.questions ?? 'N/A'}
											</p>
											<p className='text-gray-600'>
												<strong>Questions to Skip:</strong> {data[`part${part}`]?.skip ?? 'N/A'}
											</p>
											<p className='text-gray-600'>
												<strong>Mark per Question:</strong> {data[`part${part}`]?.mark ?? 'N/A'}
											</p>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>

					<div className='bg-white p-5 rounded-lg shadow-lg my-2'>
						<div className='flex justify-end mb-4'>
							<button className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded' onClick={() => setEdit('objective')}>
								Edit
							</button>
						</div>
						<h6 className='text-xl font-semibold text-gray-800 mb-2'>Objectives</h6>
						<ul className='list-disc pl-5 mb-4 text-gray-700'>{convertToListMemo(data?.objectives)?.length > 0 ? convertToListMemo(data?.objectives) : [data?.objectives]?.map((objective, index) => <li key={index}>{objective}</li>)}</ul>
						<h6 className='text-xl font-semibold text-gray-800 mb-2'>Reference</h6>
						{data?.references && <p className='mb-2 text-gray-600'>Suggested readings:</p>}
						<ul className='list-decimal pl-5 text-gray-700'>{convertToListMemo(data?.references)?.length > 0 ? convertToListMemo(data?.references) : [data?.references]?.map((reference, index) => <li key={index}>{reference}</li>)}</ul>
					</div>

					{data?.modules?.map((module, index) => (
						<div key={index} className='bg-white p-6 rounded-lg shadow-lg mb-6 overflow-hidden border-l-4 border-indigo-500'>
							<div className='flex justify-between items-center mb-6'>
								<h3 className='text-xl font-semibold text-indigo-700'>
									Module {module?.moduleId + 1}: {module?.name}
								</h3>
								<button
									aria-label='Edit Module'
									onClick={() => {
										refetch();
										setEdit('addModule');
										setModuleData({
											moduleId: module?.moduleId,
											subjectId: data?._id,
											points: module.points,
											marks: module.marks,
											name: module.name,
											hours: module.hours,
											partA: module.partA,
											partB: module.partB,
											partC: module.partC,
											taxonomy: module.taxonomy,
											difficulty: module.difficulty,
											important: module.important,
											type: module.type,
										});
									}}
									className='p-2 bg-green-500 hover:bg-green-600 rounded-full inline-flex items-center justify-center text-white shadow'
									title='Edit Module'>
									<svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor' strokeWidth='2' className='w-6 h-6'>
										<path strokeLinecap='round' strokeLinejoin='round' d='M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z' />
									</svg>
								</button>
							</div>
							<div className='pt-4'>
								<dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 text-gray-800'>
									<div>
										<dt className='text-sm font-medium text-indigo-600'>Hours</dt>
										<dd className='mt-1 text-sm'>{module?.hours}</dd>
									</div>
									<div>
										<dt className='text-sm font-medium text-indigo-600'>Marks</dt>
										<dd className='mt-1 text-sm'>{module?.marks}</dd>
									</div>
									<div className='sm:col-span-2 bg-white p-4 rounded-lg shadow-sm border border-gray-200'>
										<dt className='text-md font-semibold text-gray-800 mb-2'>Key Points:</dt>
										<dd className='mt-2 text-sm text-gray-700'>
											<ul className='list-disc pl-5 space-y-2'>
												{module?.points?.map((point, idx) => (
													<li key={idx} className='text-gray-700'>
														{index + 1 + '.' + (idx + 1)} - {point}
													</li>
												))}
											</ul>
										</dd>
									</div>

									<div className='mb-6'>
										<h4 className='font-semibold text-gray-800 mb-4'>Module Details:</h4>

										<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
											<div>
												<h5 className='text-md font-semibold text-gray-700 mb-2'>Bloom's Taxonomy:</h5>
												<div className='flex flex-wrap gap-2'>
													{module?.taxonomy?.map((level, idx) => (
														<div key={idx} className={`px-4 py-2 rounded-lg text-white ${getColorForCategoryMemo('taxonomy', level)} flex items-center gap-2`}>
															<i className='fas fa-brain'></i>
															<span>{level}</span>
														</div>
													))}
												</div>
											</div>

											<div>
												<h5 className='text-md font-semibold text-gray-700 mb-2'>Importance:</h5>
												<div className='flex flex-wrap gap-2'>
													{module?.important?.map((level, idx) => (
														<div key={idx} className={`px-4 py-2 rounded-lg text-white ${getColorForCategoryMemo('importance', level)} flex items-center gap-2`}>
															<span>{level}</span>
														</div>
													))}
												</div>
											</div>

											<div>
												<h5 className='text-md font-semibold text-gray-700 mb-2'>Difficulty:</h5>
												<div className='flex flex-wrap gap-2'>
													{module?.difficulty?.map((level, idx) => (
														<div key={idx} className={`px-4 py-2 rounded-lg text-white ${getColorForCategoryMemo('difficulty', level)} flex items-center gap-2`}>
															<span>{level}</span>
														</div>
													))}
												</div>
											</div>

											<div>
												<h5 className='text-md font-semibold text-gray-700 mb-2'>Type:</h5>
												<div className='flex flex-wrap gap-2'>
													{module?.type?.map((level, idx) => (
														<div key={idx} className={`px-4 py-2 rounded-lg text-white ${getColorForCategoryMemo('type', level)} flex items-center gap-2`}>
															<span>{level}</span>
														</div>
													))}
												</div>
											</div>
										</div>
									</div>

									<div>
										<h4 className='font-semibold text-gray-800 mb-2'>Blueprint:</h4>
										<div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
											<div className='bg-blue-200 rounded-lg p-4 text-center'>
												<h5 className='font-bold text-blue-800'>Part A</h5>
												<p>Questions: {module?.partA}</p>
											</div>
											<div className='bg-green-200 rounded-lg p-4 text-center'>
												<h5 className='font-bold text-green-800'>Part B</h5>
												<p>Questions: {module?.partB}</p>
											</div>
											<div className='bg-red-200 rounded-lg p-4 text-center'>
												<h5 className='font-bold text-red-800'>Part C</h5>
												<p>Questions: {module?.partC}</p>
											</div>
										</div>
									</div>
								</dl>
							</div>
						</div>
					))}

					<Button
						type='update'
						onClick={() => {
							setEdit('addModule');
							refetch();
							setModuleData({
								moduleId: data?.modules?.length || 0,
								subjectId: data?._id,
							});
						}}>
						Add Module
					</Button>
				</Body>
			</Main>

			{edit === 'main' ? (
				<AddSubject onClose={() => setEdit()} data={data} />
			) : edit === 'objective' ? (
				<ObjectiveEdit
					onClose={() => {
						setEdit();
						refetch();
					}}
					data={data}
				/>
			) : edit === 'addModule' ? (
				<AddModule
					values={moduleData}
					onClose={() => {
						setEdit();
						refetch();
					}}
				/>
			) : null}
		</>
	);
}







const getSubjectsWithId = (collegeId, searchItems) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/subject/getSubjectByFilter', {
			params: { collegeId, searchItems, limit: 50 },
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data?.finalArray;
		}
	} catch (error) {
		throw new Error('API Error');
	}
};


function SubjectBank({ onClose }) {
	const { collegeId, user } = useContext(FirebaseContext);
	const [subject, setSubject] = useState();
	const [addSubject, setAddSubject] = useState(false);
	const [data, setData] = useState([]);
	const [search, setSearch] = useState('');

	const { data: subjectBank = [], refetch } = useQuery(['getSubdddjects', collegeId, search], getSubjectsWithId(collegeId, search));

	console.log({ subjectBank });

	return (
		<>
			<Main width='auto' height='auto ' title='Subject Bank'>
				<Header>
					<div className='flex justify-self-center'>
						<input
							type='search'
							placeholder='search'
							onChange={(e) => {
								setSearch(e.target.value.toLowerCase());
							}}
						/>
						<Button type='save' onClick={() => setAddSubject(true)}>
							Add New Subject
						</Button>
					</div>

					<div className='flex'>
						<Instruction keyId={'subjectBank'}></Instruction>
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					</div>
				</Header>
				<Body>
					<div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 p-4'>
						{subjectBank?.map((x) => (
							<div
								key={x?._id}
								onClick={async () => {
									const instance = await getAxiosTokenInstance();
									const { data } = await instance.get('/college/subject/getSubjectsWithId', {
										params: {
											id: x?._id,
										},
									});
									setSubject(data?.subjectObject);
								}}
								className='cursor-pointer bg-white rounded-lg border border-gray-200 shadow-lg hover:shadow-xl transition-shadow duration-300 ease-in-out overflow-hidden flex flex-col'>
								<div className='w-full aspect-square overflow-hidden'>
									<img src={x.creatorPhotoURL || 'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_1280.png'} alt='User' className='object-cover object-center w-full h-full' />
								</div>

								<div className='flex-grow p-4 bg-white rounded-lg shadow hover:shadow-lg transition-shadow duration-300 ease-in-out'>
									<h5 className='text-xl font-bold text-gray-900 mb-4'>{x?.name}</h5>
									<ul className='text-sm text-gray-700 list-disc list-inside space-y-2'>
										<li>
											<strong className='text-gray-900'>SY:</strong> {x.year}
										</li>
										<li>
											<strong className='text-gray-900'>CODE:</strong> {x.subjectCode}
										</li>
										<li>
											<strong className='text-gray-900'>Added:</strong> {new Date(x.createdOn).toLocaleDateString()}
										</li>
										<li>
											<strong className='text-gray-900'>By:</strong> {x.creatorName}
										</li>
										<li>
											<strong className='text-gray-900'>College:</strong> {x.collegeName}
										</li>
									</ul>
								</div>
							</div>
						))}
					</div>
				</Body>
			</Main>
			{subject ? <SubjectDetails onClose={() => setSubject()} data={subject} /> : null}
			{addSubject ? <AddSubject onClose={() => setAddSubject()} /> : null}
		</>
	);
}



export default SubjectBank;
